import type { TableQuery } from 'ab-common/dataStructures/tableQuery';

import baseRoute from '../baseRoute';
import type { W_Order_FindExpenseReportTable_QP_AdditionalFilters } from './queryParams';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}/expenseReportTable${`?query=${Encoded<string>}&startDate=${string}&endDate=${string}&timezone=${string}&additionalFilters=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/expenseReportTable`;

export const URL = (
	tableRequestModel: TableQuery,
	startDate: Nullable<string>,
	endDate: Nullable<string>,
	timezone: Nullable<string>,
	additionalFilters: W_Order_FindExpenseReportTable_QP_AdditionalFilters
): RouteDefinition => `${baseRoute}/expenseReportTable?query=${encodeURIComponent((JSON.stringify(tableRequestModel)))}&startDate=${startDate}&endDate=${endDate}&timezone=${timezone}&additionalFilters=${encodeURIComponent((JSON.stringify(additionalFilters)))}`;
